import React from 'react';
import { Text, View, Page } from '@react-pdf/renderer';
import { styles } from '../../utils/styles';
import { ios, pageOrientation, pageSize, safari } from '../../utils';
import { PrintHeaderPDFComponent } from '../Header';
import { PrintFooterPDFComponent } from '../Footer';
import defaults from '../../translations/en.json';
import { AgencyHeader, Allergies } from './components/PatientElements';
import { Physicians } from './components/Physicians';
import { Caregivers } from './components/Caregivers';
import { AssociatedFacilities } from './components/AssociatedFacilities';
import { PatientAssignments } from './components/PatientAssignments';
import { PatientHeader } from './components/PatientHeader';
import { Medications } from './components/Medications';
import { PatientInformation } from './components/PatientInformation';
import { NeedsConcerns } from './components/NeedsConcerns';
import { AdditionalDiagnoses, PatientCondition } from './components/PatientCondition';
import { Referral } from './components/Referral';
import { parseFacesheet } from './utils';
import { FACESHEET } from './constants';

const Notes = ({
  comments
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.borderBottomBlack]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.printerHeaderText
}, defaults.notes), /*#__PURE__*/React.createElement(Text, {
  style: [styles.FacesheetText, styles.pYPointOneCm]
}, comments));

var _ref = /*#__PURE__*/React.createElement(View, null);

var _ref2 = /*#__PURE__*/React.createElement(View, null);

var _ref3 = /*#__PURE__*/React.createElement(View, null);

var _ref4 = /*#__PURE__*/React.createElement(View, null);

var _ref5 = /*#__PURE__*/React.createElement(View, null);

var _ref6 = /*#__PURE__*/React.createElement(View, null);

var _ref7 = /*#__PURE__*/React.createElement(View, null);

var _ref8 = /*#__PURE__*/React.createElement(View, null);

var _ref9 = /*#__PURE__*/React.createElement(PrintFooterPDFComponent, null);

export const FacesheetPDF = ({
  patient,
  browser,
  dto
}) => {
  const facesheet = dto[FACESHEET];
  const {
    associatedFacilities,
    physicians,
    caregivers,
    patientAssignments,
    patientCondition,
    patientMedications,
    currentFacility,
    programSiteName,
    noAssignments,
    allergies,
    facesheetPatient,
    comments,
    primaryFundingSource,
    dnr,
    crm,
    referralSource,
    referralTakenBy,
    referralTakenOn,
    callingPerson,
    referringFacility
  } = parseFacesheet(facesheet);
  const pageStyle = browser && browser.name === safari || browser && browser.name === ios ? styles.pageSafari : styles.page;
  const headerStyle = [styles.row, styles.width100, styles.alignItemsCenter, styles.borderBottomBlack];
  return patient && /*#__PURE__*/React.createElement(Page, {
    wrap: false,
    size: pageSize,
    orientation: pageOrientation,
    style: pageStyle
  }, /*#__PURE__*/React.createElement(PrintHeaderPDFComponent, {
    browser: browser,
    patient: patient
  }), /*#__PURE__*/React.createElement(AgencyHeader, {
    patient: patient
  }), /*#__PURE__*/React.createElement(View, {
    style: headerStyle
  }, /*#__PURE__*/React.createElement(PatientHeader, {
    patient: facesheetPatient,
    condition: patientCondition,
    siteName: programSiteName,
    currentFacility: currentFacility
  })), /*#__PURE__*/React.createElement(PatientInformation, {
    patient: facesheetPatient,
    fundingSource: primaryFundingSource
  }), /*#__PURE__*/React.createElement(NeedsConcerns, {
    patient: facesheetPatient
  }), allergies ? /*#__PURE__*/React.createElement(Allergies, {
    allergies: allergies
  }) : _ref, patientCondition && /*#__PURE__*/React.createElement(PatientCondition, {
    condition: patientCondition,
    dnr: dnr
  }), physicians ? /*#__PURE__*/React.createElement(Physicians, {
    physicians: physicians
  }) : _ref2, caregivers ? /*#__PURE__*/React.createElement(Caregivers, {
    caregivers: caregivers
  }) : _ref3, associatedFacilities ? /*#__PURE__*/React.createElement(AssociatedFacilities, {
    associatedFacilities: associatedFacilities
  }) : _ref4, !noAssignments ? /*#__PURE__*/React.createElement(PatientAssignments, {
    assignments: patientAssignments
  }) : _ref5, comments ? /*#__PURE__*/React.createElement(Notes, {
    comments: comments
  }) : _ref6, /*#__PURE__*/React.createElement(Referral, {
    crm: crm,
    callingPerson: callingPerson,
    referralTakenBy: referralTakenBy,
    referralTakenOn: referralTakenOn,
    referralSource: referralSource,
    referringFacility: referringFacility
  }), patientCondition ? /*#__PURE__*/React.createElement(AdditionalDiagnoses, {
    diagnoses: patientCondition.diagnoses && patientCondition.diagnoses.diagnosis
  }) : _ref7, patientMedications ? /*#__PURE__*/React.createElement(Medications, {
    meds: patientMedications
  }) : _ref8, _ref9);
};